import api from './baseApi';

const uploadApi = {
  uploadFile: (params) => {
    return api.post('/v1/manage-admin/upload/upload-file', params);
  },
};

export default uploadApi;
